import { render, staticRenderFns } from "./SoftFairTarifdaten.vue?vue&type=template&id=ae165708&"
import script from "./SoftFairTarifdaten.vue?vue&type=script&lang=js&"
export * from "./SoftFairTarifdaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports